import { BrandTabsTypes } from 'stores/brands/types';

export const brandTabs: BrandTabsTypes[] = ['basic', 'catalogues'];
